// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard{width:100%;height:100%;min-width:1000px;overflow:hidden}.vue-grid-item.vue-grid-placeholder{background:#009688!important;opacity:.2;transition-duration:.1s;z-index:2;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
